import script from "./ComptesView.vue?vue&type=script&setup=true&lang=js"
export * from "./ComptesView.vue?vue&type=script&setup=true&lang=js"

import "./ComptesView.vue?vue&type=style&index=0&id=508fa556&lang=css"

const __exports__ = script;

export default __exports__